export default __webpack_public_path__ + "img/fNLDWeRn.f0377e18.svg";